import Vue from "vue";
import VueRouter from "vue-router";
import Locations from "../views/Locations.vue";
import MultiBookingAdmin from "../views/MultiBookingAdmin.vue";
import BookingAdmin from "../views/BookingAdmin.vue";
import Tools from "../views/Tools.vue";
import User from "../views/User.vue";
import Login from "../views/Login.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Schedule from "../views/Schedule.vue";
import NotFound from "../views/NotFound.vue";
import Control from "../views/Control.vue";
import LocationStatistic from "@/views/LocationStatistic";
import OrderPage from "@/components/OrderPage";
import IframeTest from "@/views/IframeTest";
import LocationManagement from "@/views/LocationManagement/LocationManagement";
import Payments from "@/views/LocationManagement/Payments";
import Transactions from "@/views/LocationManagement/Transactions";
import LocationSessions from "@/views/LocationManagement/LocationSessions";
import LocationOrders from "@/views/LocationManagement/LocationOrders";
import SchedulesAndPlaygrounds from "@/views/LocationManagement/SchedulesAndPlaygrounds";
import CheckPayment from "@/views/CheckPayment";
import LocationInfo from "@/views/LocationManagement/LocationInfo";
import LocationGallery from "@/views/LocationManagement/LocationGallery";
import GamesTable from "@/views/LocationManagement/GamesTable";
import CreatePage from "@/components/CreatePage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next({
          name: "locations",
        });
      }
    },
  },
  {
    path: "/user",
    name: "user",
    component: User,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      if (window.localStorage.getItem("auth_token")) {
        return next({
          name: "locations",
        });
      } else {
        next();
      }
    },
  },
  {
    path: "/password_reset/:hash",
    name: "password_reset",
    component: ResetPassword,
    beforeEnter: (to, from, next) => {
      if (window.localStorage.getItem("auth_token")) {
        return next({
          name: "locations",
        });
      } else {
        next();
      }
    },
  },
  {
    path: "/locations",
    name: "locations",
    component: Locations,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/tools",
    name: "tools",
    component: Tools,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/location_management",
    name: "location_management",
    component: LocationManagement,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/location_info",
    name: "location_info",
    component: LocationInfo,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/location_gallery",
    name: "location_gallery",
    component: LocationGallery,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/games_table",
    name: "games_table",
    component: GamesTable,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/payments",
    name: "payments",
    component: Payments,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/transactions",
    name: "transactions",
    component: Transactions,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/sessions",
    name: "sessions",
    component: LocationSessions,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/orders",
    name: "orders",
    component: LocationOrders,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/schedules_and_playgrounds",
    name: "schedules_and_playgrounds",
    component: SchedulesAndPlaygrounds,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/check_payment/:payment_id/",
    name: "check_payment",
    component: CheckPayment,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/multibooking_admin",
    name: "multibooking_admin",
    component: MultiBookingAdmin,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/booking_admin",
    name: "booking_admin",
    component: BookingAdmin,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/statistic",
    name: "statistic",
    component: LocationStatistic,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/new_schedule",
    name: "new_schedule",
    component: Schedule,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/schedule/:schedule_id",
    name: "schedule",
    component: Schedule,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/orders/:order_id",
    name: "order",
    component: OrderPage,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/locations/:location_id/create",
    name: "create",
    component: CreatePage,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/404",
    name: "404",
    component: NotFound,
  },
  {
    path: "*",
    redirect: "/404",
  },
  {
    path: "/control",
    name: "control",
    component: Control,
    beforeEnter: (to, from, next) => {
      if (!window.localStorage.getItem("auth_token")) {
        return next({
          name: "login",
        });
      } else {
        return next();
      }
    },
  },
  {
    path: "/iframe",
    name: "iframe",
    component: IframeTest,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
